import React from 'react';
import PlaceholderPage from './PlaceholderPage';
import { MenuBook } from '@mui/icons-material';

const PolicyLedgerPage = () => (
  <PlaceholderPage
    title="Policy Ledger"
    description="Comprehensive ledger of all policy transactions, premiums, and payouts."
    icon={<MenuBook sx={{ fontSize: 56 }} />}
  />
);

export default PolicyLedgerPage;
